import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { calculateTextExprValue, isArrayNotEmpty } from '@/common/util/util';
export const config = {
    value: 'setTableOpenKeys',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, _context, state, urlParamsDataSource } = config || {};
        const { options } = buttonConfig || {};
        const { _bindTable, openKeys } = options || {};
        function selectOneTable(id, keys) {
            if (typeof id === 'string') {
                const table = _context.$(id);
                if (table) {
                    const innerInfo = table.getRemoteOperation?.()?.current?.innerInfo;
                    if (innerInfo) {
                        innerInfo?.setTreeKeys(keys);
                    }
                }
            }
        }
        if (isArrayNotEmpty(_bindTable) && _context && openKeys) {
            const realOpenKeys = calculateTextExprValue(openKeys, {
                urlParamsDataSource,
                recordDataSource: {},
                state,
            });
            if (isArrayNotEmpty(realOpenKeys)) {
                _bindTable.forEach((item) => {
                    selectOneTable(item, realOpenKeys);
                });
            }
        }
    },
};
